import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { ScoresService } from 'src/app/service/scores.service';
import { FileService } from 'src/app/service/file.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { DatePipe } from '@angular/common'
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
@Component({
  selector: 'app-re-take-exam-create',
  templateUrl: './re-take-exam-create.component.html',
  styleUrls: ['./re-take-exam-create.component.scss']
})
export class ReTakeExamCreateComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;
  highlightColors: any = [];
  courses: any = [];
  students: any = [];
  coursesAssessUnits: any = [];
  yearId: any;
  semesterId: any;
  batchId: any;
  examScoreFile: any;
  examScoreFileName: any;
  orgId: any;
  username: any;
  status = 'DRAFT';
  currentExamId: any;

  reTakeExamCreateForm = new FormGroup({
    subjectid: new FormControl('', [
      Validators.required,
    ]),
    studentid: new FormControl('', [
      Validators.required,
    ]),
    retakeScore: new FormControl('', [
      Validators.required,
    ]),
    remarks: new FormControl('', [
      // Validators.required,
    ]),
    retakeDate: new FormControl('', [
      // Validators.required,
    ]),
    // status: new FormControl('', [
    //   // Validators.required,
    // ]),
  });

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private roleService: RoleService
    , private orgService: OrgService
    , private datePipe: DatePipe
    , private scoresService: ScoresService
    , private enrollmentGroupService: EnrollmentGroupService
    , private fileService: FileService
    , public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService
  ) {

  }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.yearId = params['yearId'] || "";
        this.semesterId = params['semesterId'] || "";
        this.batchId = params['batchId'] || "";

        if (this.yearId != "" && this.semesterId != "" && this.batchId != "") {
          this.getBatchCourses(this.batchId);
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/exams/final-examinations'], { queryParams: { yearId: this.yearId, semesterId: this.semesterId, batchId: this.batchId } });
        }
      });
  }

  reTakeExamCreateFormChange() {
    // let classHours = this.createType.controls.classHours.value;
    // let clinicalHours = this.createType.controls.clinicalHours.value;
    // this.createType.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  reTakeExamCreateFormSubmit() {
    if (this.reTakeExamCreateForm.valid) {
      let retakenExamObj = this.reTakeExamCreateForm.value;
      // scoreDataObj.filename = this.examScoreFileName;
      this.addReTakeExam(retakenExamObj);

    }
    else {
      this.reTakeExamCreateForm.markAllAsTouched();
      this.reTakeExamCreateForm.markAsDirty();
    }
  }

  addReTakeExam(retakenExamObj: any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;
    retakenExamObj.yearid = this.yearId;
    retakenExamObj.semesterid = this.semesterId;
    retakenExamObj.gradeid = this.batchId;
    retakenExamObj.retakeStatus = "DRAFT";

    // Call API TO create final examinations
    // Test start
    this.toastrService.success("create success");
    this.creating = false;
    // Test end
    this.scoresService.addRetakenExamData(username, this.orgId, retakenExamObj)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.router.navigate(['/exams/re-take-exam'], { queryParams: { yearId: this.yearId, semesterId: this.semesterId, batchId: this.batchId } });
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          this.creating = false;
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }

  getBatchCourses(batchId: number) {
    this.showLoader = true;
    this.enrollmentGroupService.getBatchSubjects(this.orgId, batchId)
      .subscribe(
        data => {
          this.courses = data;
          this.getAllStudent();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        },
        () => { this.showLoader = false }
      );
  }

  getAllStudent() {
    this.showLoader = true;
    this.enrollmentAcceptedStudentService.getAllStudents()
      .subscribe(
        data => {
          this.students = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        },
        () => { this.showLoader = false }
      );
  }

  // getCourseAssessUnits() {
  //   this.coursesAssessUnits = [];
  //   let courseId = this.reTakeExamCreateForm.controls.subjectid.value;
  //   this.scoresService.getAllAssesmentUnit()
  //     .subscribe(
  //       data => {
  //         this.coursesAssessUnits = data;
  //       },
  //       error => {
  //         this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
  //       }
  //     );
  // }



  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() { }



}



